import React, { Component } from 'react';
import * as Fa from 'react-icons/lib/fa';
import swal from 'sweetalert';
import AddressBook from './AddressBookModal';
import Pagination from '../../../components/Pagination';
import Spinner from '../../../components/Spinner';
import UserGroup from '../../../services/UserGroup';

const UserGroupService = new UserGroup();

export default class UserGroups extends Component {
  state = {
    page: 1,
    limit: 10,
    total: 0,
    pagination: [],
    data: [],
    loading: false,
    mode: 'list',

    // form
    name: '',
    selectedMembers: {
      raw: [],
      str: '',
    }
  }

  componentDidMount = () => {
    window.store.dispatch(window.actions.showPageTitle(true));
    if (window.store.getState().rootReducers.currentUser.role !== 'ADMIN') {
      window.browserHistory.push('/');
      return;
    }
    this.setState({ loading: true }, () => {
      let opt = { page: this.state.page, limit: this.state.limit, search: this.state.searchString }
      UserGroupService.getAll(opt)
        .then((result) => {
          this.setState({
            page: result.page,
            limit: result.limit,
            total: result.total,
            data: result.data || [],
            loading: false,
          });
        })
        .catch((err) => {
          this.setState({
            data: [],
            loading: false,
          });
        });
    });
  }

  inputEventHandler = (event) => {
    let val = (event.target.getContent && event.target.getContent()) || event.target.value;
    let obj = {};
    obj[event.target.name] = val;
    this.setState(obj);
  }

  page = (page) => {
    page = page || 1;
    this.setState({ loading: true, filterValue: '' });
    let opt = { page: page, limit: this.state.limit, search: this.state.searchString }
    UserGroupService.getAll(opt)
      .then((result) => {
        this.setState({
          page: result.page,
          limit: result.limit,
          total: result.total,
          data: result.data || [],
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          data: [],
          loading: false,
        });
      });
  }

  next = () => {
    this.setState({ loading: true, filterValue: '' });
    let opt = { page: this.state.page + 1, limit: this.state.limit, search: this.state.searchString }
    UserGroupService.getAll(opt)
      .then((result) => {
        this.setState({
          page: result.page,
          limit: result.limit,
          total: result.total,
          data: result.data || [],
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          data: [],
          loading: false,
        });
      });
  }

  prev = () => {
    this.setState({ loading: true, filterValue: '' });
    let opt = { page: this.state.page - 1, limit: this.state.limit, search: this.state.searchString }
    UserGroupService.getAll(opt)
      .then((result) => {
        this.setState({
          page: result.page,
          limit: result.limit,
          total: result.total,
          data: result.data || [],
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          data: [],
          loading: false,
        });
      });
  }

  back = () => {
    this.setState({
      mode: 'list',
      id: null,
      name: null,
      members: [],
      loading: false
    }, () => {
      this.reload();
    });
  }

  new = () => {
    this.setState({
      mode: 'form',
      id: null,
      name: null,
      members: [],
      selectedMembers: { raw: [], str: '' }
    });
  }

  edit = (item) => {
    this.setState({
      mode: 'form',
      id: null,
      name: null,
      selectedMembers: { raw: [], str: '' }
    }, () => {
      let obj = {}
      obj.id = item.id;
      obj.name = item.name;
      obj.selectedMembers = { raw: [], str: '' }
      for (let i in item.members) {
        obj.selectedMembers.raw.push(item.members[i].split('|')[0]);
        if (obj.selectedMembers.str.length > 0) {
          obj.selectedMembers.str += "\n "
        }
        obj.selectedMembers.str += item.members[i].split('|')[1]
      }
      this.setState(obj);
    });
  }

  reload = () => {
    this.page()
  }

  search = () => {
    this.reload()
  }

  dismissSearch = () => {
    this.setState({ searchString: '' }, () => {
      this.reload()
    });
  }

  handleSearchString = (e) => {
    if (e && e.target) {
      console.log(e.target.value);
      this.setState({ searchString: e.target.value });
    }
  }

  isDefaultSwitched = (checked) => {
    this.setState({ isDefault: checked ? true : false });
  }

  save = () => {
    const payload = {
      id: this.state.id || null,
      name: this.state.name,
      members: [],
    }
    for (let i in this.state.selectedMembers.raw) {
      payload.members.push(this.state.selectedMembers.raw[i])
    }
    this.setState({ loading: true });
    if (payload.id) {
      UserGroupService.update(payload.id, payload)
        .then(() => {
          this.back();
        })
        .catch((err) => {
          console.log(err);
          this.setState({ loading: false });
        });
    } else {
      UserGroupService.create(payload)
        .then(() => {
          this.back();
        })
        .catch((err) => {
          console.log(err);
          this.setState({ loading: false });
        });
    }
  }

  delete = () => {
    swal({
      title: '',
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Batal',
      text: 'Anda yakin ingin menghapus grup ini?',
    }, (ok) => {
      if (ok) {
        UserGroupService.delete(this.state.id)
          .then(() => {
            this.back();
          })
          .catch((err) => {
            console.log(err);
            this.setState({ loading: false });
          });
      }
    });

  }

  membersOnChange = (event) => {
    let val = (event.target.getContent && event.target.getContent()) || event.target.value;
    let obj = {};
    if (event.target.raw) {
      obj[event.target.name] = obj[event.target.name] || { raw: [], str: '' }
      obj[event.target.name].str = val;
      obj[event.target.name].raw = event.target.raw;
    } else {
      obj[event.target.name] = val;
    }
    this.setState(obj);
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-12">
          {this.state.mode === 'list' &&
            <div style={{ float: 'right' }}>
              <span className="btn btn-default" onClick={this.new}>
                <Fa.FaPlus /> Tambah grup pengguna
            </span>
            </div>
          }
          <h4>
            {this.state.mode !== 'list' && <Fa.FaChevronLeft style={{ marginRight: 15, cursor: 'pointer' }} onClick={this.back} />}
            {this.state.mode === 'list' ? 'Grup Pengguna' :
              (this.state.id ? 'Sunting Grup Pengguna' : 'Buat Grup Pengguna Baru')}
          </h4>
          {this.state.mode === 'form' &&
            <div className="box box-success">
              <div className="box-body" style={{ padding: 0 }}>
                <div className="row" style={{ margin: 15 }}>
                  <div className="col-md-12">
                    <div className="form-group row">
                      <label style={{ textAlign: 'right' }} className="col-md-1 col-sm-2">Nama Grup</label>
                      <div className="col-md-10 col-sm-9" >
                        <input
                          className="form-control"
                          name="name"
                          placeholder="Nama Grup"
                          value={this.state.name}
                          onChange={(e) => { this.setState({ name: e.target.value }) }}
                        />
                        <small id="nameHelp" className="form-text text-muted">Harap diisi</small>
                      </div>
                    </div>
                    <AddressBook
                      style={{ float: 'right' }}
                      label="Anggota"
                      value={this.state.selectedMembers.str}
                      raw={this.state.selectedMembers.raw}
                      single={false}
                      name={'selectedMembers'}
                      row={10}
                      onChange={this.membersOnChange}
                    />
                    {this.state.loading ?
                      <Spinner /> :
                      <div className="form-group row">
                        <div className="col-md-11" style={{ textAlign: 'right' }} >
                          {this.state.id &&
                            <button className="btn btn-danger" onClick={this.delete}>Hapus</button>
                          }
                          &nbsp;&nbsp;
                        <button className="btn btn-primary" onClick={this.save}>Simpan</button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          {this.state.mode === 'list' &&
            <div className="box box-success">
              <div className="box-body" style={{ padding: 0 }}>
                <div className="row" style={{ padding: 15 }}>
                  <div className="col-sm-12 col-md-6 col-lg-8">
                    <div className="input-group input-group-sm">
                      <span className="input-group-btn">
                        <span className="btn btn-success">
                          <Fa.FaRefresh />
                        </span>
                      </span>
                      <input
                        className="form-control" type="text"
                        onChange={this.handleSearchString}
                        onKeyPress={(e) => { if (e.key === 'Enter') this.search() }}
                        value={this.state.searchString}
                      />
                      {this.state.searchString && this.state.searchString.length > 0 &&
                        <span className="input-group-btn">
                          <span className="btn btn-default" onClick={this.dismissSearch}>
                            <Fa.FaClose />
                          </span>
                        </span>
                      }
                      <span className="input-group-btn">
                        <span className="btn btn-default" onClick={this.search}>
                          <Fa.FaSearch />
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div style={{ float: 'right' }}>
                      <Pagination
                        disabled={this.state.loading}
                        page={this.state.page}
                        limit={this.state.limit}
                        total={this.state.total}
                        prev={this.prev} next={this.next}
                        toPage={this.page} />
                    </div>
                  </div>
                  <hr />
                </div>
                {this.state.loading ? <Spinner /> :
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Nama group</th>
                        <th>Jumlah anggota</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(this.state.data).map((item, index) => {
                        return <tr key={index} onClick={() => { this.edit(this.state.data[item]) }} style={{ cursor: 'pointer' }}>
                          <td>{this.state.data[item].name}</td>
                          <td>{this.state.data[item].members.length}</td>
                          <td></td>
                        </tr>
                      })}
                    </tbody>
                  </table>
                }
                {!(this.state.total > 0) && !this.state.loading &&
                  <div style={{ textAlign: 'center', marginTop: 50, marginBottom: 50 }}>
                    <br />
                    <h4>Tidak ada data</h4>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}
